export default __webpack_public_path__ + "static/media/dash1.6883d62f.svg";